import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { selectWorkTypesExist } from '../../services/workTypes/selectors';

interface OwnProps {
    children: React.ReactNode;
}

interface ConnectedProps {
    workTypesExist: boolean;
}

type Props = OwnProps & ConnectedProps;

export class OrganizationHasWorkTypesGate extends React.PureComponent<Props> {
    render(): React.ReactNode | null {
        const { workTypesExist, children } = this.props;

        if (!workTypesExist) return null;

        return children;
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    workTypesExist: selectWorkTypesExist
});

export default connect(mapStateToProps)(OrganizationHasWorkTypesGate);
